import * as z from 'zod/v4/mini';

export enum DropzoneUrlDialogFieldNames {
	Url = 'url'
}

export enum DropzoneUrlDialogErrorMessage {
	InvalidUrl = 'Please enter a valid file URL'
}

export const DropzoneUrlDialogValidationSchema = z.object({
	[DropzoneUrlDialogFieldNames.Url]: z
		.string()
		.check(
			z.url(DropzoneUrlDialogErrorMessage.InvalidUrl),
			z.minLength(1, DropzoneUrlDialogErrorMessage.InvalidUrl)
		)
});
